import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 5h-8v10h8m-1 -5h-7","key":"svg-0"}],["path",{"d":"M6 20l0 .01","key":"svg-1"}],["path",{"d":"M10 20l0 .01","key":"svg-2"}],["path",{"d":"M14 20l0 .01","key":"svg-3"}],["path",{"d":"M18 20l0 .01","key":"svg-4"}]]

const IconEmphasis = createReactComponent('outline', 'emphasis', 'Emphasis', __iconNode);

export default IconEmphasis;